//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'driverEdit',
    data() {
        return {
            formData:{
                id:0,
                title:'',
                phone:'',
                take_reward:'',
                send_reward:'',
            },
        }
    },
    created() {
        this.formData.id = Number(this.$route.params.id);
        if(this.formData.id > 0){
            this.driverInfo();
        }
    },
   
    methods: {
        driverInfo() {
            this.$api.driverList({id:this.formData.id}).then((res)=>{
                if(res){
                    this.formData = res.data;
                }
            })  
        },
        submit() {
            if(!this.formData.title){
                this.$func.showToast('请输入姓名');
                return false;
            }
            if(!this.formData.phone){
                this.$func.showToast('请输入手机号');
                return false;
            }
            if(!this.formData.take_reward){
                this.$func.showToast('请输入取衣提成');
                return false;
            }
            if(!this.formData.send_reward){
                this.$func.showToast('请输入送衣提成');
                return false;
            }
            this.$api.submitDriver(this.formData).then((res)=>{
                if(res){
                    this.$func.showToast('提交成功');
                    setTimeout(()=>{
                        this.$router.go(-1);
                    },300)
                }
            });
        },
    }
}



// WEBPACK FOOTER //
// ./src/pages/driverEdit.vue